import { useMutation } from "@tanstack/react-query";
import axios, { AxiosError } from "axios";
import { displayNotify } from "../../../../../services/Notifications/NotificationServices";
import { useQueryClient } from "@tanstack/react-query";
import { camouflageKeys, CamouflageOwnerType } from "../../types/camouflageTypes";

interface camouflageInfo {
    camouflages: string[]
}

export default function useUserCreateCamouflage(type: CamouflageOwnerType, slug: string | null | undefined) {
    const queryClient = useQueryClient()

    const qKeys = camouflageKeys[type]
    // /api/v1/users/me/camouflages/
    // /api/v1/teams/{team_slug}/camouflages/

    return useMutation({
        mutationFn: (newCamouflage: string[]) => { 
            const endpoint = type === 'profile' ? '/users/me/camouflages/' : `/teams/${slug}/camouflages/`
            return axios.post(endpoint, {new_camouflage: newCamouflage})
        },
        onSuccess: () => {
            displayNotify({
                status: 'success',
                title: 'Камуфляж создан',
                description: ''
            })
            queryClient.invalidateQueries({ queryKey: qKeys });
        },
        onError: (error: AxiosError) => {
            displayNotify({
                status: 'error',
                title: 'Камуфляж не создан',
                description: `${error?.status}`
            })
        }
    })
}